import { action } from 'satcheljs/lib/legacy';
import store from '../store/store';
import MailboxJunkEmailConfigurationOptions from 'owa-service/lib/contract/MailboxJunkEmailConfigurationOptions';
import setMailboxJunkEmailConfiguration from '../services/setMailboxJunkEmailConfiguration';

export default action('saveMailboxJunkMailConfiguration')(
    async function saveMailboxJunkMailConfiguration(
        mailboxJunkEmailConfiguration: MailboxJunkEmailConfigurationOptions
    ) {
        store.mailboxJunkEmailConfiguration = mailboxJunkEmailConfiguration;
        await setMailboxJunkEmailConfiguration(mailboxJunkEmailConfiguration);
    }
);
